import React, { useEffect } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import { Box, styled, Typography } from "@mui/material";
import { Block } from "./account/accountPieces";
import { AccountWrap } from "./account/components/pieces";
import type { AppContext, Size } from "../types";

const Iframe = styled(Box)<{ src?: string; component?: React.ElementType }>(() => ({
    width: `100%`,
    overflow: `hidden`,
    border: `none`,
}));

const receiveIframeHeight = (event: MessageEvent<{ type: string; height: number }>) => {
    if (event.data.type === `iframeHeight`) {
        const iframe = document.querySelector<HTMLIFrameElement>(`#contentframe`);
        iframe!.style.setProperty(`height`, `${event.data.height}px`);
    }
};

const InfoPage = ({ context }: { context: AppContext }) => {
    const { page } = useParams();
    const [size] = useOutletContext<[Size, (open?: unknown) => void]>();

    useEffect(() => {
        window.addEventListener(`message`, receiveIframeHeight);
        return () => window.removeEventListener(`message`, receiveIframeHeight);
    }, []);

    return (
        <Block size={size}>
            <AccountWrap size={size}>
                {!context.adminConfig?.mp_iframe_content?.[`${page}_url`] && (
                    <Typography sx={{ textAlign: `center`, paddingTop: `200px` }} variant="h6" gutterBottom>
                        The content for this page is currently unavailable.
                    </Typography>
                )}
                <Iframe
                    component="iframe"
                    id="contentframe"
                    title="contentframe"
                    src={context.adminConfig?.mp_iframe_content?.[`${page}_url`] as string}
                />
            </AccountWrap>
        </Block>
    );
};

export default InfoPage;
